// extracted by mini-css-extract-plugin
export var animationContainer = "_n0-0";
export var footer = "_n0-1";
export var gray = "_n0-2";
export var lineItem = "_n0-3";
export var lineItemImage = "_n0-4";
export var lineItemInfo = "_n0-5";
export var lineItemText = "_n0-6";
export var lineItems = "_n0-7";
export var modalContent = "_n0-8";
export var options = "_n0-9";
export var orderName = "_n0-a";
export var refundAmount = "_n0-b";